import classNames from 'classnames';

import './call-to-action.scss';

import type { CallToActionProps } from './types';
import { Button } from '../../atoms/Button';

export const CallToAction = ({
  title,
  description,
  buttonLabel,
  onButtonClick,
  buttonVariant,
  borderless = false,
}: CallToActionProps) => {
  return (
    <div
      className={classNames('payflow-ui call-to-action', {
        'call-to-action--borderless': borderless,
      })}
    >
      <div className="contents">
        <div className="copy">
          <span className="title">{title}</span>
          <span className="description">{description}</span>
        </div>
        <Button className="button" onClick={onButtonClick} variant={buttonVariant}>
          <span className="button-text">{buttonLabel}</span>
        </Button>
      </div>
    </div>
  );
};
